import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import * as firebaseUi from 'firebaseui';
import { BehaviorSubject, distinctUntilChanged, filter } from 'rxjs';
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBwIHQCsza7FFc_9MllBUSjfUOvHGn7Tec',
  projectId: 'cytoreason-scriba',
  appId: '1:553541681890:web:ac76e1c1c37276e02e54bb',
  messagingSenderId: '553541681890',
  measurementId: 'G-XTTHSC0S3S',
  authDomain: 'cytoreason-scriba.firebaseapp.com',
  databaseURL: 'https://cytoreason-scriba-default-rtdb.europe-west1.firebasedatabase.app',
  storageBucket: 'cytoreason-scriba.appspot.com',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth();
const authUI = new firebaseUi.auth.AuthUI(auth);
const userSubject$ = new BehaviorSubject(undefined);
const user$ = userSubject$.asObservable().pipe(distinctUntilChanged(), filter(user => user !== undefined));
onAuthStateChanged(auth, userSubject$);

export const firebase = {
  app, analytics, auth, authUI, user$, userUid() {
    return firebase.auth.currentUser.uid;
  },
};

const bucketBaseUrl = `https://firebasestorage.googleapis.com/v0/b/${firebaseConfig.storageBucket}/o/`;

export function storageFileUrl(path) {
  return bucketBaseUrl + encodeURIComponent(path);
}
